import { useEffect } from 'react'
import * as C from './styles.js'
import { Link } from 'react-router-dom'
import { useState } from 'react';

export default function Episodes({ user, movie, imdb_id, episodes, season, setSeason }) {

    const [ layoutStyle, setLayoutStyle ] = useState('grid');
    const [ episodesLengthVisible, setEpisodesLengthVisible ] = useState(20);

    useEffect(()=>{
        setEpisodesLengthVisible(20);
    }, [episodes])
    
    function dataConvert(data) {
        // Converte a string de data para um objeto Date
        const dataObj = new Date(data);
        
        // Obtém o dia, mês e ano do objeto Date
        const dia = String(dataObj.getDate()).padStart(2, '0');
        const mes = String(dataObj.getMonth() + 1).padStart(2, '0');
        const ano = dataObj.getFullYear();
        
        // Obtém o idioma do localStorage ou usa o idioma padrão 'portugues'
        const language = localStorage.getItem('idioma') || 'portugues';
    
        // Verifica o idioma e formata a data de acordo
        if (language === 'ingles') {
            // Formato inglês: mm/dd/yyyy
            return `${mes}/${dia}/${ano}`;
        } else {
            // Formato padrão português: dd/mm/yyyy
            return `${dia}/${mes}/${ano}`;
        }
    }
    
    const converter = (minutos) => {
        const horas = Math.floor(minutos/ 60);
        const min = minutos % 60;
        const textoHoras = (`${horas}`);
        const textoMinutos = (`${min}`);

        if (minutos <= 59) {
            return `${textoMinutos}min`;
        } else if (minutos == 60) {
            return `${textoHoras }h`;
        } else if (minutos >= 61) {
            return `${textoHoras }h, ${textoMinutos}min`;
        }
    };

    const loadMore = () => {
        const remainingEpisodes = episodes.length - episodesLengthVisible;
        const nextBatch = Math.min(remainingEpisodes, 10);
        setEpisodesLengthVisible(prevCastLengthVisible => prevCastLengthVisible + nextBatch);
    };

    return(
        <C.Container layoutStyle={layoutStyle}>
            <header>
                <h2 className='h2-elenco-details-movie h2-titulo-sections'>Episódios</h2>
                <div>
                    <button className={layoutStyle == 'grid' && 'active'} onClick={()=>setLayoutStyle('grid')}><i class="fa-solid fa-grip"></i></button>
                    <button className={layoutStyle == 'list' && 'active'} onClick={()=>setLayoutStyle('list')}><i class="fa-solid fa-bars"></i></button>
                </div>
            </header>
            <div className='container-episodes'>
                {episodes?.slice(0, episodesLengthVisible).map((episode)=>{
                    return (
                        <Link className='episode' to={`?detalhes=temporadas&temporada=${season}&episodio=${episode?.episode_number}`}>
                            <img className={episode?.still_path ? "has-image" : "no-image"} src={episode?.still_path ? `https://image.tmdb.org/t/p/w400${episode?.still_path}` : `https://www.themoviedb.org/assets/2/v4/glyphicons/basic/glyphicons-basic-38-picture-grey-c2ebdbb057f2a7614185931650f8cee23fa137b93812ccb132b9df511df1cfac.svg`} alt={`imagem do episódio ${episode?.episode_number} da temporada ${episode?.season_number} da série ${movie?.name}`}/>
                            <div className='details'>
                                <h2 title={episode?.name} className='name'><span>{episode?.episode_number}.</span> {episode?.name}</h2>
                                <section>
                                    {episode?.vote_average > 0 &&
                                        <span><i className='fas fa-star'></i> {episode?.vote_average.toFixed(1)}</span>
                                    }
                                    {episode?.air_date != '' &&
                                        <span><i class="fa-solid fa-calendar"></i> {dataConvert(episode?.air_date)}</span>
                                    }
                                    {episode?.runtime > 0 &&
                                        <span><i class="fa-solid fa-clock"></i> {converter(episode?.runtime)}</span>
                                    }
                                </section>
                                <p className='overview'>{episode?.overview != '' ? episode?.overview : 'Não há uma descrição para este episódio'}</p>
                            </div>
                        </Link>
                    )
                })}
            </div>
            {episodes?.length > episodesLengthVisible &&
                <section className="section-more-movies">
                    <button className="botao-playlist botao-add-playlist" onClick={loadMore}><i className="fas fa-plus"></i></button>
                </section>
            }
        </C.Container>
    )
}